import React, {Component} from 'react';

import ff from './ff';
import bf from './bf';
import ic from './ic';
import cf from './cf';
import ce from './ce';
import cr from './cr';

import cView from './cView';

export default class i16v extends cView { // 設備予約　管理用用画面

constructor(props) { // state の宣言だけでは駄目な模様
  super(props);
  this.state = cf.myRN_crt_stss(
    this.$cd_stss,
    this.$id_stss
  );
}

$cd_stgs = { //  子で上書き
};

$cd_stss = { // 親を上書き
  sdld_i16rListsss: {i16r:[]},
  sdld_i16rDtlsss: {i16r:[]},
};

$clp_loadLists = () => [ // 親を上書き
  i16v.op_loadList({
    elm: 'i16r',
    ld_sortss: [
      { fld: 'i16rc11s', dtn: 'asc', mode: 'nmb' }
    ],
  }),
];

$clp_loadDtls = () => [
  i16v.op_loadDtl({
    elm: 'i16r',
  }),
  i16v.op_loadVsnList({ // 時間帯
    elm: 'i16r',
  }),
];

$clp_upds = () => [
  cr.myCB_call_tree({
    ctr: 'iud',
    state: 'sdld_i16rDtlsss',
    b_vsn: true,
    dd_elmDefss: {
      i16r: {
        b_setPageKey: true,
        od_insDats: _dd_datss => {
          let _d = {
            i16rc11s: _dd_datss.i16r.d_flds.i16rc11s ?? '',
            i16rc31s: _dd_datss.i16r.d_flds.i16rc31s ?? '',
          };
          return _d;
        },
      },
    },
  }),
];

render() {
  return (
    ce.c(ce.RootDtl, {
      key: -1,
      d_hdrs: {
        pfx:
          (global.t?.state.sgc_pnlMode == 'list') ?
            '団体活動カテゴリ一覧・登録'
          : (global.t?.state.sgc_pnlMode == 'dtl' && global.t?.state.sgc_pageMode == 'show') ?
            '団体活動カテゴリ変更'
          : (global.t?.state.sgc_pnlMode == 'dtl' && global.t?.state.sgc_pageMode == 'edit') ?
            '団体活動カテゴリ変更'
          : (global.t?.state.sgc_pnlMode == 'dtl' && global.t?.state.sgc_pageMode == 'new') ?
            '団体活動カテゴリ変更'
          : null,
        d_subs: 
          ff.i(global.t?.state.sgc_pageMode, ['new', 'edit']) == false ?
            {
              iconName: 'users',
              pfx: 'ユーザ切替',
              o_onPrs: () => {
                let _d_pageInfs = {
                  sgc_pageRole: global.t?.state.sgc_pageRole,
                  sgc_pageName: 'c00v2a',
                  sgc_pageMode: 'show',
                };
                cf.myRN_move_fwd(_d_pageInfs);
              },
            }
          : null,
      },
      d_bdys: {
        l_clds: [
          ce.c(ce.Pnl, {
            key: -1,
            mode: 'list',
            b_vsb: (global.t?.state.sgc_pnlMode == 'list') ? true : false,
            d_bdys: {
              d_msgBfrs: {
                pfx: `【活動カテゴリの変更】･･･IDを押すと変更画面に移動します。`,
                n_mgnTop: ic.s(1),
                d_stlCtas: {
                  minWidth: ic.gn_bdyW,
                },
              },
              l_clds: [

                ce.c(ce.Box, {
                  key: -10,
                  n_mgnTop: ic.s(1),
                }, [

                  ce.c(cr.InpTree, {
                    key: -1,
                    state: 'sdld_i16rListsss',
                    dd_elmDefss: {
                      i16r: {
                        elm: 'i16r',
                        b_row: true,
                        b_rootHdr: true,
                        b_ttl: false,
                        d_insFlds: cf.e('i16r').d_insFlds,
                        d_btns: {
                          d_dlts: {
                            b_vsb: (global.t?.state.sgc_pageMode == 'edit') ? true : false,
                          },
                        },
/*
                        d_hdrs: {
                          d_cells: {
                            ln_ws: [ic.s(6), ic.s(16)],
                            n_h: ic.s(2.2),
                          },
                        },
                        d_bdys: {
                          d_cells: {
                            ln_ws: [ic.s(6), ic.s(16)],
                            n_h: ic.s(2.2),
                          },
                        },
*/
                        d_stlHdrRows: {
                          height: ic.s(1.8),
                        },
                        d_stlBdyRows: {
                          height: ic.s(2.2),
                          marginTop: ic.s(0.2)
                        },
                        dd_fldDefss: cf.myRN_getFldDefs([
                          cf.f('i16rc11s', {
                            b_key: true,
                            d_hdrs: { n_w: ic.s(6)  },
                            d_bdys: { n_w: ic.s(6) },
                          }),
                          cf.f('i16rc31s', {
                            d_hdrs: { n_w: ic.s(16)  },
                            d_bdys: { n_w: ic.s(16) },
                          }),
                        ]),
                      },
                    },
                  }),

                ])
              ],
            },
            d_btms: {
/*
              d_news: {
                elm: 'i16r',
                state: 'sdld_i16rDtlsss',
                d_insFlds: cf.e('i16r').d_insFlds,
              },
*/
              l_clds: [
                ce.c(ce.Box, {
                  key: -2,
                  stlCta: {
                    minHeight: ic.s(2 * 2),
                    width: ic.gn_minBdyW,
                    flexDirection: 'row',
                    justifyContent: 'space-around',
                    alignItems: 'center',
                    marginTop: ic.s(0.5), // 20211202
                    marginBottom: ic.s(0.5), // 20211202
                    marginLeft: 'auto',
                    marginRight: 'auto',
                  }
                }, [
                  ce.c(ce.Btn, {
                    key: -20,
                    pfx: '前の画面に戻る',
                    stlBtn: {
                      width: ic.s(8),
                      backgroundColor: ic.g_ccdHN,
                      borderColor: ic.g_ccdHN,
                    },
                    o_onPrs: () => {
                      let _d_pageInfs = {
                        sgc_pageRole: global.t?.state.sgc_pageRole,
                        sgc_pageName: 'iStg1',
                        sgc_pageMode: 'show',
                      }; 
                      cf.myRN_move_fwd(_d_pageInfs);
                    },
                  }),
                  ce.c(ce.Btn, {
                    key: -10,
                    pfx: '活動カテゴリの新規登録',
                    b_rvs: false,
                    stlBtn: {
                      width: ic.s(12),
                    },
                    o_onPrs: () => {
                      cf.myRN_chgPageMode({
                        elm: 'i16r',
                        state: 'sdld_i16rDtlsss',
                        d_insFlds: cf.e('i16r').d_insFlds,
                        mode: 'sttNew',
                        b_clr: true, // 現行要素の初期化に必要
                      })
                    },
                  }),
                ])
              ],

            }
          }),

          ce.c(ce.Pnl, {
            key: -2,
            mode: 'dtl',
            b_vsb: (global.t?.state.sgc_pnlMode == 'dtl') ? true : false,
            d_hdrs: {
              d_htys: {
                elm: 'i16r',
                ld_iss: global.t?.state.sdld_i16rVsnListsss?.i16r,
                op_loadDtl: i16v.op_loadDtl,
              },
            },
            d_bdys: {
              l_clds: [
                ce.c(ce.Box, {
                  key: -10,
                  n_mgnTop: ic.s(1),
                }, [
                  ce.c(cr.InpTree, {
                    key: -1,
                    state: 'sdld_i16rDtlsss',
                    dd_elmDefss: {
                      i16r: {
                        elm: 'i16r',
                        b_ttl: true,
                        d_insFlds: cf.e('i16r').d_insFlds,
                        d_btns: {
                          d_dlts: {
                            b_vsb: (global.t?.state.sgc_pageMode == 'edit') ? true : false,
                          },
                        },
                        d_cmns: {
                          n_cnt: 1,
                        },
                        dd_fldDefss: cf.myRN_getFldDefs([
                          cf.f('i16rc11s', {
                            d_hdrs: { n_w: ic.s(6)  },
                            d_bdys: { n_w: ic.s(16) },
                          }),
                          cf.f('i16rc31s', {
                            d_hdrs: { n_w: ic.s(6)  },
                            d_bdys: { n_w: ic.s(16) },
                          }),
                        ]),
                      },
                    },
                  }),
                ])
              ],
            },
            d_btms: {
/*
              l_clds: [
                ce.c(ce.Box, {
                  key: -1,
                  stlCta: {
                    height: ic.s(2),
                    flexDirection: 'row',
                    justifyContent: 'space-around',
                    alignItems: 'center',
                    width: global.t?.state.sgcd_dmns.n_bdyW,
                    marginTop: ic.m(1),
                    marginBottom: ic.m(1),
                    marginLeft: 'auto',
                    marginRight: 'auto',
                  }
                }, [
                  ce.c(ce.Btn, {
                    key: -1,
                    pfx: 'キャンセル',
                    b_vsb: global.t?.state.sgc_pageMode == 'new' ? true : false,
                    stlBtn: {
                      width: ic.s(8),
                      backgroundColor: ic.g_fontCcdSml,
                      borderColor: ic.g_fontCcdSml,
                    },
                    o_onPrs: () => {
                      cf.myRN_chgPageMode({
                        mode: 'cclNew',
                      });
                    },
                  }),
                  ce.c(ce.Btn, {
                    key: -2,
                    pfx: '登録',
                    b_vsb: global.t?.state.sgc_pageMode == 'new' ? true : false,
                    stlBtn: {
                      width: ic.s(8),
                    },
                    o_onPrs: () => {
                      cf.myRN_chgPageMode({
                        mode: 'endNew',
                      });
                    },
                  }),
                  ce.c(ce.Btn, {
                    key: -3,
                    pfx: '変更',
                    b_vsb: global.t?.state.sgc_pageMode == 'show' ? true : false,
                    stlBtn: {
                      width: ic.s(8),
                    },
                    o_onPrs: () => {
                      cf.myRN_chgPageMode({
                        mode: 'sttEdit',
                      });
                    },
                  }),
                  ce.c(ce.Btn, {
                    key: -4,
                    pfx: 'キャンセル',
                    b_vsb: global.t?.state.sgc_pageMode == 'edit' ? true : false,
                    stlBtn: {
                      width: ic.s(8),
                      backgroundColor: ic.g_fontCcdSml,
                      borderColor: ic.g_fontCcdSml,
                    },
                    o_onPrs: () => {
                      cf.myRN_chgPageMode({
                        mode: 'cclEdit',
                      });
                    },
                  }),
                  ce.c(ce.Btn, {
                    key: -5,
                    pfx: '登録',
                    b_vsb: global.t?.state.sgc_pageMode == 'edit' ? true : false,
                    stlBtn: {
                      width: ic.s(8),
                    },
                    o_onPrs: () => {
                      cf.myRN_chgPageMode({
                        mode: 'endEdit',
                      });
                    },
                  }),
                ])
              ],
*/
            }
          }),

        ],
      }
    })
  );
}

}
